export const TEAM_ONE = 1;
export const TEAM_TWO = 2;
